module.exports = __webpack_public_path__ + "static/media/pic21.ef104120.jpg";